import { Alert, Button, Card, Tooltip, Typography } from 'antd';
import React from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import OWLink from '../OWLink';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { withCurrentUser } from '../../hooks/withCurrentUser';

const ClientPortalWidget = ({ contractorClient, portal, currentUser }) => {
	if (!portal) {
		return null;
	}

	return (
		<div className="rowSpacing">
			{portal ? (
				<Card title={`Client Request Portal`}>
					<div className="">
						<div className="mb-4 rounded-xl bg-slate-200 p-3 text-base text-gray-500 ">
							<Typography.Text copyable underline>
								{`https://requests.useopenwrench.com/client-request-portal/${portal.customerSlug}/client/${portal.clientSlug}`}
							</Typography.Text>
						</div>
						<Typography.Text type="secondary">
							For <u>{contractorClient.name}</u> only.
							<Tooltip
								title={`This link is specific to ${contractorClient.name}. Do not share this link with other clients. For other clients, you will need to create a new portal.`}
							>
								<InfoCircleOutlined className="ml-2 inline-block" />
							</Tooltip>
						</Typography.Text>
						{nullSafeGet('facility.logoURL', currentUser) ? null : (
							<Alert
								style={{ marginTop: '16px' }}
								message={
									<div className="text-sm">
										Personalise your request portal by adding a logo to your company,{' '}
										<OWLink to={`/supplier/company/me`}>
											<span>click here</span>
										</OWLink>
									</div>
								}
								type="warning"
							/>
						)}
					</div>
				</Card>
			) : null}
		</div>
	);
};

export default withCurrentUser(ClientPortalWidget);
